window.bindStandingsTable = function () {
  if ($("#teams-dashboard").length === 0) return false;

  $.fn.DataTable.ext.pager.numbers_length = 5;
  var url = "/leagues/" + gon.league_id + "/teams";

  if (gon.current_season_id) {
    url += "?standings=true&season_id=" + gon.current_season_id;
    gon.season_id = gon.current_season_id;
  }

  const pageLength = window.location.href.includes("player_dashboard") ? 5 : 100;

  window.standingsTable = $("#teams-dashboard").DataTable({
    info: false,
    pageLength,
    lengthMenu: [5, 10, 25, 50, 100],
    ajax: { url },
    createdRow: function (row, data) {
      let current_player_team = data.current_player_team;
      if (data.players) {
        var team_player_ids = data.players.map((p) => p.id);
        current_player_team = team_player_ids.includes(gon.current_user_id);
      }
      if (current_player_team) {
        $(row).find("td").addClass("bg-black");
      }
    },
    ext: {
      pager: {
        numbers_length: 2,
      },
    },
    columns: [
      {
        data: "position",
        className: "text-white",
      },
      {
        data: "name",
        className: "text-primary",
      },
      {
        data: "points",
        className: "text-right",
      },
    ],
  });

  updateStandingsPdfLink();
};

function standingsTableUrl() {
  let url = `/leagues/${gon.league_id}/teams?standings=true`;

  if (gon.division_id) {
    url += `&division_id=${gon.division_id}`;
  }

  if (gon.season_id) {
    url += `&season_id=${gon.season_id}`;
  }

  if (gon.round_type_id) {
    url += `&round_type_id=${gon.round_type_id}`;
  }

  return url;
}

function updateStandingsPdfLink() {
  const $link = $("#standings-pdf-link");
  if ($link.length === 0) return;

  const params = new URLSearchParams({ league_id: gon.league_id });

  if (gon.division_id && gon.division_id !== "all") {
    params.set("division_id", gon.division_id);
  }

  if (gon.round_type_id) {
    params.set("round_type_id", gon.round_type_id);
  } else if (gon.season_id) {
    params.set("season_id", gon.season_id);
  }

  $link.attr("href", `/reports/standings.pdf?${params.toString()}`);
}

$(document).on("turbolinks:load", window.bindStandingsTable);
$(document).on("turbolinks:load", function () {
  $(".divisions-dd a.dropdown-item").on("click", function (e) {
    e.preventDefault();
    gon.division_id = $(this).data("division-id");
    window.standingsTable.ajax.url(standingsTableUrl());
    $("#divisions-dd").text($(this).text());
    updateStandingsPdfLink();
    window.standingsTable.draw();
  });

  $(".round-types-dd a.dropdown-item").on("click", function (e) {
    e.preventDefault();
    gon.round_type_id = $(this).data("round-type-id");
    window.standingsTable.ajax.url(standingsTableUrl());
    $("#round-types-dd").text($(this).text());
    updateStandingsPdfLink();
    window.standingsTable.draw();
  });

  $(".seasons-dd a.dropdown-item").on("click", function (e) {
    e.preventDefault();
    gon.season_id = $(this).data("season-id");
    gon.round_type_id = null;
    window.standingsTable.ajax.url(standingsTableUrl());
    $("#seasons-dd").text($(this).text());
    $("#round-types-dd").text("Pick a round");
    updateStandingsPdfLink();
    window.standingsTable.draw();
  });
});
